import { render, staticRenderFns } from "./TestComparison.vue?vue&type=template&id=dc94ad74&scoped=true&"
import script from "./TestComparison.vue?vue&type=script&lang=js&"
export * from "./TestComparison.vue?vue&type=script&lang=js&"
import style0 from "./TestComparison.vue?vue&type=style&index=0&id=dc94ad74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc94ad74",
  null
  
)

export default component.exports